import { Dispositif } from '@domain/dispositif/dispositif';

export class Participant {
  constructor(
    public readonly id: number | undefined,
    public readonly firstName: string,
    public readonly lastName: string,
    public readonly birthDate: Date,
    public readonly active: boolean,
    public readonly dispositifs: Dispositif[] = [],
  ) {}
}
